import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { galleryImages } from '../mock';

export default function AboutSection() {
  return (
    <section className="bg-[#f4f1eb] py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-light opacity-60" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <img
                src={galleryImages[2]}
                alt="Welder at work"
                className="rounded-xl aspect-[3/4] object-cover w-full shadow-2xl"
              />
              <div className="space-y-4 pt-10">
                <img
                  src={galleryImages[1]}
                  alt="Welding sparks"
                  className="rounded-xl aspect-square object-cover w-full shadow-xl"
                />
                <div className="rounded-xl bg-[#0b0b0d] text-white p-5 shadow-xl">
                  <div className="font-display text-4xl font-semibold text-amber-400">1985</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/60 mt-1">
                    Established
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-600 mb-4">
              — Our Journey
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-semibold text-[#0b0b0d] leading-[1.05]">
              Four decades of welding excellence.
            </h2>
            <p className="mt-6 text-neutral-700 leading-relaxed">
              Based in the industrial heart of Kota, Rajasthan, <span className="font-semibold">Prakash Electrodes Private Limited </span>
              has quietly powered India&rsquo;s fabrication industry since 1985. From humble
              workshops to sprawling steel plants, our electrodes have laid the seams that hold
              together roads, bridges, machines, and homes.
            </p>
            <p className="mt-4 text-neutral-700 leading-relaxed">
              Five iconic brands — <span className="font-semibold">Weldarc, CUTWELD, Hitkari Gold,
              BPL,</span> and <span className="font-semibold">Sunlight</span> — stand as testimony to
              our uncompromising standards and endless pursuit of the perfect weld.
            </p>

            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/about">
                <Button className="btn-primary bg-[#0b0b0d] hover:bg-[#0b0b0d] text-white font-semibold h-11 px-6 rounded-md">
                  Read Full Story <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
